// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1500px) {
  nav .nav-list a {
    font-size: 16px;
  }

  header nav {
    padding-left: 4%;
    padding-right: 4%;
  }

  navbar-content {
    transition: transform 0.4s;
  }

  .navbar-hidden {
    transform: translateY(-74px);
  }

  .hero-container img {
    width: 100%;
    height: 100%;
  }

  .grid-card {
    padding: 0 4%;
  }

  .footer-container {
    padding: 0 4%;
  }

  .container-diagnose {
    padding: 0 4%;
  }

  .container-diagnose h1 {
    margin-top: 72px;
  }

  .container-about {
    padding: 0 4%;
  }
}

@media (max-width: 990px) {  
  nav #hamburger {
    font-size: 32px;
    border: none;
    background-color: transparent;
    display: block;
    min-width: 44px;
    min-height: 44px;
    padding: 16px;
  }

  .nav-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    position: fixed;
    top: -100%;
    right: 0;
    z-index: -9999;
    border-radius: 0 !important;
    padding: 80px 4% 0 4%;
    transition: top 0.3s ease-in-out;
    color: #000;
    background-color: #fff;
  }

  nav .nav-list a {
    padding: 0px;
  }

  .container-navbar {
    top: 0px;;
  }

  header nav {
    padding-left: 4% !important;
    padding-right: 4% !important;
    width: 100%;
    border-radius: 0px;
    position: relative;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
    backdrop-filter: none;
  }

  .nav-list li a {
    font-size: 24px;
    padding: 20px 0;
  }

  .nav-list.open {
      top: 0;
  }

  .nav-list li {
    line-height: 24px;
    border-bottom: 1px solid #ddd;
  }

  nav .btn {
    display: none;
  }
  
  .navbar-hidden {
    transform: translateY(-74px);
  }

  .hero-container h1 {
    font-size: 52px;
  }

  .hero-container img {
    width: 100%;
    height: 100%;
  }

  .card-testi-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .container-testimonial {
    padding: 100px 4%;
    border-radius: 40px;
  }

  .container-diagnose {
    padding: 0 4%;
  }

  .navbar-hidden {
    transform: none !important;
  }

  .container-about .main-content {
    flex-direction: column;
    gap: 32px;
    text-align: center;
  }

  .container-about .text-content,
  .container-about .img-content {
    max-width: 100%;
  }

  .container-about .img-content img {
    width: 100%;
  }

  .container-about .content-two .text-content {
    order: 2;
  }
  
  .container-about .content-two .img-content {
    order: 1;
  }

  .container-about .text-content {
    max-width: 32rem;
  }

  .main-content > * {
    max-width: 100%;
    box-sizing: border-box;
  }
}

@media (max-width: 899px) {
  nav #hamburger {
    font-size: 32px;
    border: none;
    background-color: transparent;
    display: block;
    min-width: 44px;
    min-height: 44px;
    padding: 16px;
  }

  .nav-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    position: fixed;
    top: -200%;
    right: 0;
    z-index: -99999999;
    border-radius: 0 !important;
    padding: 80px 4% 0 4%;
    transition: top 0.3s ease-in-out;
    color: #000;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
  }

  nav .nav-list a {
    padding: 0px;
  }

  .container-navbar {
    top: 0px;
  }

  .navbar-hidden {
    transform: none !important;
  }

  header nav {
    padding-left: 4%;
    padding-right: 4%;
    width: 100%;
    position: relative;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    background-color: #fff;
  }

  .nav-list li a {
    font-size: 24px;
    padding: 20px 0;
  }

  .nav-list.open {
      top: 0;
  }

  .nav-list li {
    line-height: 24px;
    border-bottom: 1px solid #ddd;
  }

  .navbar-hidden {
    transform: none !important;
  }

  .hero-container h1 {
    font-size: 44px;
  }
  
  .hero-container .text-wrapper {
    max-width: 32rem;
  }

  .hero-container img {
    width: 100%;
    height: 100%;
  }

  .grid-item {
    grid-column: span 1 / span 1;
  }   
  .grid-card {
      grid-row-gap: 24px;
      flex-direction: column;
      grid-template-rows: auto;
      grid-template-columns: 1fr;
      grid-auto-columns: 1fr;
      display: grid;
      padding: 0 4%;
  }
  
  .container-diagnose {
    padding: 0 4%;
  }
  .container-main {
    padding: 0 4%;
  }
}

@media (max-width: 678px) {
  nav #hamburger {
    font-size: 32px;
    border: none;
    background-color: transparent;
    display: block;
    min-width: 44px;
    min-height: 44px;
    padding: 16px;
  }

  .nav-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    position: fixed;
    top: -100%;
    right: 0;
    z-index: -999;
    border-radius: 0 !important;
    padding: 80px 4% 0 4%;
    transition: top 0.3s ease-in-out;
    color: #333;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
  }

  nav .nav-list a {
    padding: 0px;
  }

  header nav {
    padding-left: 4%;
    padding-right: 4%;
    width: 100%;
    position: relative;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    background-color: #fff;
  }

  .nav-list li a {
    font-size: 24px;
    padding: 20px 0;
  }

  .nav-list.open {
      top: 0;
  }

  .nav-list li {
    line-height: 24px;
    border-bottom: 1px solid #ddd;
  }

  header .hero .text-content h1{
    font-size: 38px;
    color:#ffff;
  }

  header .hero .text-content p {
    font-size: 18px;
  }

  header .hero .text-content {
    max-width: 29rem;
  }

  .container-diagnose {
    padding: 0 4%;
  }

  .hero-container img {
    width: 100%;
    height: 100%;
  }

  .footer-container {
    padding: 0 4%;
  }

  .footer-container {
    grid-template-columns: 1fr;
  }

  .main-content {
    grid-template-columns: 1fr; /* 👈 Ini penting supaya item stack ke bawah */
  }

  .hero-container h1 {
    font-size: 38px;
  }

  .hero-container .text-content {
    max-width: 32rem;
  }

  .grid-item {
    grid-column: span 1 / span 1;
  }  

  .grid-card {
      grid-row-gap: 24px;
      flex-direction: column;
      grid-template-rows: auto;
      grid-template-columns: 1fr;
      grid-auto-columns: 1fr;
      display: grid;
      padding: 0 4%;
  }

  .container-fitur .text-head h1 {
    font-size:32px;
  }

  .card-testi-container {
    grid-template-columns: repeat(1, 1fr);
  }

  .footer-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 440px) {
  nav #hamburger {
    font-size: 32px;
    border: none;
    background-color: transparent;
    display: block;
    min-width: 44px;
    min-height: 44px;
    padding: 16px;
  }

  .nav-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    position: fixed;
    top: -100%;
    right: 0;
    z-index: -999;
    border-radius: 0 !important;
    padding: 80px 4% 0 4%;
    transition: top 0.3s ease-in-out;
    color: #333;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
  }

  nav .nav-list a {
    padding: 0px;
  }

  header nav {
    padding-left: 4%;
    padding-right: 4%;
    position: relative;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    background-color: #fff;
  }

  .nav-list li a {
    font-size: 24px;
    padding: 20px 0;
  }

  .nav-list.open {
      top: 0;
  }

  .nav-list li {
    line-height: 24px;
    border-bottom: 1px solid #ddd;
  }

  .hero-container img {
    width: 100%;
    height: 100%;
  }

  .hero-container h1 {
    font-size: 35px;
  }

  .hero-container .text-content {
    max-width: 22rem;
  }

  .container-diagnose h1 {
    font-size: 32px;
  }

  .footer-container {
    padding: 0 4%;
  }

  .footer-container {
    flex-direction: column;
  }

  .footer-container .main-content {
    flex-direction: column;
    gap: 32px;
  }

  footer p {
    font-size: 14px;
  }

  .container-about .text-content h2 {
    font-size: 28px;
  }
}

@media (max-width: 380px) {
  nav #hamburger {
    font-size: 32px;
    border: none;
    background-color: transparent;
    display: block;
    min-width: 44px;
    min-height: 44px;
    padding: 16px;
  }

  .nav-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    position: fixed;
    top: -100%;
    right: 0;
    z-index: -999;
    border-radius: 0 !important;
    padding: 80px 4% 0 4%;
    transition: top 0.3s ease-in-out;
    color: #333;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
  }

  nav .nav-list a {
    padding: 0px;
  }

  header nav {
    padding-left: 4%;
    padding-right: 4%;
    position: relative;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    background-color: #fff;
  }

  .nav-list li a {
    font-size: 24px;
    padding: 20px 0;
  }

  .nav-list.open {
      top: 0;
  }

  .nav-list li {
    line-height: 24px;
    border-bottom: 1px solid #ddd;
  }

  .hero-container h1 {
    font-size: 34px;
  }

  .hero-container .text-content {
    max-width: 21rem;
  }

  .hero-container img {
    width: 100%;
    height: 100%;
  }

  .container-fitur .text-head h1 {
    font-size: 34px;
  }

  .container-about .text-head h1 {
    font-size: 34px;
  }
  .container-testimonial h1 {
    font-size: 34px;
  }

  .getstarted-container h1 {
    font-size: 32px;
  }

  .footer-container {
    padding: 0 4%;
  }

  .footer-container {
    flex-direction: column;
  }

  footer p {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,cAAc;IACd,2BAA2B;IAC3B,qBAAqB;IACrB,gCAAgC;IAChC,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,+CAA+C;IAC/C,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;MACI,MAAM;EACV;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;IAC3B,qBAAqB;IACrB,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;MACI,MAAM;EACV;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;EACA;MACI,kBAAkB;MAClB,sBAAsB;MACtB,wBAAwB;MACxB,0BAA0B;MAC1B,sBAAsB;MACtB,aAAa;MACb,aAAa;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,aAAa;IACb,2BAA2B;IAC3B,qBAAqB;IACrB,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;MACI,MAAM;EACV;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B,EAAE,8CAA8C;EAC5E;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;MACI,kBAAkB;MAClB,sBAAsB;MACtB,wBAAwB;MACxB,0BAA0B;MAC1B,sBAAsB;MACtB,aAAa;MACb,aAAa;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,aAAa;IACb,2BAA2B;IAC3B,qBAAqB;IACrB,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;MACI,MAAM;EACV;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,aAAa;IACb,2BAA2B;IAC3B,qBAAqB;IACrB,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;MACI,MAAM;EACV;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@media (max-width: 1500px) {\r\n  nav .nav-list a {\r\n    font-size: 16px;\r\n  }\r\n\r\n  header nav {\r\n    padding-left: 4%;\r\n    padding-right: 4%;\r\n  }\r\n\r\n  navbar-content {\r\n    transition: transform 0.4s;\r\n  }\r\n\r\n  .navbar-hidden {\r\n    transform: translateY(-74px);\r\n  }\r\n\r\n  .hero-container img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .grid-card {\r\n    padding: 0 4%;\r\n  }\r\n\r\n  .footer-container {\r\n    padding: 0 4%;\r\n  }\r\n\r\n  .container-diagnose {\r\n    padding: 0 4%;\r\n  }\r\n\r\n  .container-diagnose h1 {\r\n    margin-top: 72px;\r\n  }\r\n\r\n  .container-about {\r\n    padding: 0 4%;\r\n  }\r\n}\r\n\r\n@media (max-width: 990px) {  \r\n  nav #hamburger {\r\n    font-size: 32px;\r\n    border: none;\r\n    background-color: transparent;\r\n    display: block;\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n    padding: 16px;\r\n  }\r\n\r\n  .nav-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n    position: fixed;\r\n    top: -100%;\r\n    right: 0;\r\n    z-index: -9999;\r\n    border-radius: 0 !important;\r\n    padding: 80px 4% 0 4%;\r\n    transition: top 0.3s ease-in-out;\r\n    color: #000;\r\n    background-color: #fff;\r\n  }\r\n\r\n  nav .nav-list a {\r\n    padding: 0px;\r\n  }\r\n\r\n  .container-navbar {\r\n    top: 0px;;\r\n  }\r\n\r\n  header nav {\r\n    padding-left: 4% !important;\r\n    padding-right: 4% !important;\r\n    width: 100%;\r\n    border-radius: 0px;\r\n    position: relative;\r\n    padding-top: 0 !important;\r\n    padding-bottom: 0 !important;\r\n    background-color: #fff;\r\n    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\r\n    backdrop-filter: none;\r\n  }\r\n\r\n  .nav-list li a {\r\n    font-size: 24px;\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .nav-list.open {\r\n      top: 0;\r\n  }\r\n\r\n  .nav-list li {\r\n    line-height: 24px;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  nav .btn {\r\n    display: none;\r\n  }\r\n  \r\n  .navbar-hidden {\r\n    transform: translateY(-74px);\r\n  }\r\n\r\n  .hero-container h1 {\r\n    font-size: 52px;\r\n  }\r\n\r\n  .hero-container img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .card-testi-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .container-testimonial {\r\n    padding: 100px 4%;\r\n    border-radius: 40px;\r\n  }\r\n\r\n  .container-diagnose {\r\n    padding: 0 4%;\r\n  }\r\n\r\n  .navbar-hidden {\r\n    transform: none !important;\r\n  }\r\n\r\n  .container-about .main-content {\r\n    flex-direction: column;\r\n    gap: 32px;\r\n    text-align: center;\r\n  }\r\n\r\n  .container-about .text-content,\r\n  .container-about .img-content {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .container-about .img-content img {\r\n    width: 100%;\r\n  }\r\n\r\n  .container-about .content-two .text-content {\r\n    order: 2;\r\n  }\r\n  \r\n  .container-about .content-two .img-content {\r\n    order: 1;\r\n  }\r\n\r\n  .container-about .text-content {\r\n    max-width: 32rem;\r\n  }\r\n\r\n  .main-content > * {\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n\r\n@media (max-width: 899px) {\r\n  nav #hamburger {\r\n    font-size: 32px;\r\n    border: none;\r\n    background-color: transparent;\r\n    display: block;\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n    padding: 16px;\r\n  }\r\n\r\n  .nav-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n    position: fixed;\r\n    top: -200%;\r\n    right: 0;\r\n    z-index: -99999999;\r\n    border-radius: 0 !important;\r\n    padding: 80px 4% 0 4%;\r\n    transition: top 0.3s ease-in-out;\r\n    color: #000;\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  nav .nav-list a {\r\n    padding: 0px;\r\n  }\r\n\r\n  .container-navbar {\r\n    top: 0px;\r\n  }\r\n\r\n  .navbar-hidden {\r\n    transform: none !important;\r\n  }\r\n\r\n  header nav {\r\n    padding-left: 4%;\r\n    padding-right: 4%;\r\n    width: 100%;\r\n    position: relative;\r\n    padding-top: 0 !important;\r\n    padding-bottom: 0 !important;\r\n    background-color: #fff;\r\n  }\r\n\r\n  .nav-list li a {\r\n    font-size: 24px;\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .nav-list.open {\r\n      top: 0;\r\n  }\r\n\r\n  .nav-list li {\r\n    line-height: 24px;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  .navbar-hidden {\r\n    transform: none !important;\r\n  }\r\n\r\n  .hero-container h1 {\r\n    font-size: 44px;\r\n  }\r\n  \r\n  .hero-container .text-wrapper {\r\n    max-width: 32rem;\r\n  }\r\n\r\n  .hero-container img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .grid-item {\r\n    grid-column: span 1 / span 1;\r\n  }   \r\n  .grid-card {\r\n      grid-row-gap: 24px;\r\n      flex-direction: column;\r\n      grid-template-rows: auto;\r\n      grid-template-columns: 1fr;\r\n      grid-auto-columns: 1fr;\r\n      display: grid;\r\n      padding: 0 4%;\r\n  }\r\n  \r\n  .container-diagnose {\r\n    padding: 0 4%;\r\n  }\r\n  .container-main {\r\n    padding: 0 4%;\r\n  }\r\n}\r\n\r\n@media (max-width: 678px) {\r\n  nav #hamburger {\r\n    font-size: 32px;\r\n    border: none;\r\n    background-color: transparent;\r\n    display: block;\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n    padding: 16px;\r\n  }\r\n\r\n  .nav-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n    position: fixed;\r\n    top: -100%;\r\n    right: 0;\r\n    z-index: -999;\r\n    border-radius: 0 !important;\r\n    padding: 80px 4% 0 4%;\r\n    transition: top 0.3s ease-in-out;\r\n    color: #333;\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  nav .nav-list a {\r\n    padding: 0px;\r\n  }\r\n\r\n  header nav {\r\n    padding-left: 4%;\r\n    padding-right: 4%;\r\n    width: 100%;\r\n    position: relative;\r\n    padding-top: 0 !important;\r\n    padding-bottom: 0 !important;\r\n    background-color: #fff;\r\n  }\r\n\r\n  .nav-list li a {\r\n    font-size: 24px;\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .nav-list.open {\r\n      top: 0;\r\n  }\r\n\r\n  .nav-list li {\r\n    line-height: 24px;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  header .hero .text-content h1{\r\n    font-size: 38px;\r\n    color:#ffff;\r\n  }\r\n\r\n  header .hero .text-content p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  header .hero .text-content {\r\n    max-width: 29rem;\r\n  }\r\n\r\n  .container-diagnose {\r\n    padding: 0 4%;\r\n  }\r\n\r\n  .hero-container img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .footer-container {\r\n    padding: 0 4%;\r\n  }\r\n\r\n  .footer-container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .main-content {\r\n    grid-template-columns: 1fr; /* 👈 Ini penting supaya item stack ke bawah */\r\n  }\r\n\r\n  .hero-container h1 {\r\n    font-size: 38px;\r\n  }\r\n\r\n  .hero-container .text-content {\r\n    max-width: 32rem;\r\n  }\r\n\r\n  .grid-item {\r\n    grid-column: span 1 / span 1;\r\n  }  \r\n\r\n  .grid-card {\r\n      grid-row-gap: 24px;\r\n      flex-direction: column;\r\n      grid-template-rows: auto;\r\n      grid-template-columns: 1fr;\r\n      grid-auto-columns: 1fr;\r\n      display: grid;\r\n      padding: 0 4%;\r\n  }\r\n\r\n  .container-fitur .text-head h1 {\r\n    font-size:32px;\r\n  }\r\n\r\n  .card-testi-container {\r\n    grid-template-columns: repeat(1, 1fr);\r\n  }\r\n\r\n  .footer-container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 440px) {\r\n  nav #hamburger {\r\n    font-size: 32px;\r\n    border: none;\r\n    background-color: transparent;\r\n    display: block;\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n    padding: 16px;\r\n  }\r\n\r\n  .nav-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n    position: fixed;\r\n    top: -100%;\r\n    right: 0;\r\n    z-index: -999;\r\n    border-radius: 0 !important;\r\n    padding: 80px 4% 0 4%;\r\n    transition: top 0.3s ease-in-out;\r\n    color: #333;\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  nav .nav-list a {\r\n    padding: 0px;\r\n  }\r\n\r\n  header nav {\r\n    padding-left: 4%;\r\n    padding-right: 4%;\r\n    position: relative;\r\n    padding-top: 0 !important;\r\n    padding-bottom: 0 !important;\r\n    background-color: #fff;\r\n  }\r\n\r\n  .nav-list li a {\r\n    font-size: 24px;\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .nav-list.open {\r\n      top: 0;\r\n  }\r\n\r\n  .nav-list li {\r\n    line-height: 24px;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  .hero-container img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .hero-container h1 {\r\n    font-size: 35px;\r\n  }\r\n\r\n  .hero-container .text-content {\r\n    max-width: 22rem;\r\n  }\r\n\r\n  .container-diagnose h1 {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .footer-container {\r\n    padding: 0 4%;\r\n  }\r\n\r\n  .footer-container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .footer-container .main-content {\r\n    flex-direction: column;\r\n    gap: 32px;\r\n  }\r\n\r\n  footer p {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .container-about .text-content h2 {\r\n    font-size: 28px;\r\n  }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n  nav #hamburger {\r\n    font-size: 32px;\r\n    border: none;\r\n    background-color: transparent;\r\n    display: block;\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n    padding: 16px;\r\n  }\r\n\r\n  .nav-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n    position: fixed;\r\n    top: -100%;\r\n    right: 0;\r\n    z-index: -999;\r\n    border-radius: 0 !important;\r\n    padding: 80px 4% 0 4%;\r\n    transition: top 0.3s ease-in-out;\r\n    color: #333;\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  nav .nav-list a {\r\n    padding: 0px;\r\n  }\r\n\r\n  header nav {\r\n    padding-left: 4%;\r\n    padding-right: 4%;\r\n    position: relative;\r\n    padding-top: 0 !important;\r\n    padding-bottom: 0 !important;\r\n    background-color: #fff;\r\n  }\r\n\r\n  .nav-list li a {\r\n    font-size: 24px;\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .nav-list.open {\r\n      top: 0;\r\n  }\r\n\r\n  .nav-list li {\r\n    line-height: 24px;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  .hero-container h1 {\r\n    font-size: 34px;\r\n  }\r\n\r\n  .hero-container .text-content {\r\n    max-width: 21rem;\r\n  }\r\n\r\n  .hero-container img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .container-fitur .text-head h1 {\r\n    font-size: 34px;\r\n  }\r\n\r\n  .container-about .text-head h1 {\r\n    font-size: 34px;\r\n  }\r\n  .container-testimonial h1 {\r\n    font-size: 34px;\r\n  }\r\n\r\n  .getstarted-container h1 {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .footer-container {\r\n    padding: 0 4%;\r\n  }\r\n\r\n  .footer-container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  footer p {\r\n    font-size: 14px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
